import { setMobileMenuPosition } from "./primary-navigation";
import { initializeOwlCarousel } from "./homepage";
import { sendDataToGa4 } from './ga4-push-to-gtm';
import { getDataFromCourseCard, convertNameToId } from "./ga4";
import { setTopSpace } from './top-space';

var $ = jQuery;

let stateUrl;   // Internal URL (not the browser's URL) to keep filters state.

/**
 * All browser's URL calls should be passed thru that filter
 */
function applyBrowserURLFilter( url ) {
    // If the state URL is initiated, use it in favor of the browser's URL.
    if (stateUrl) {
        url = stateUrl;
    }

    return url;
}

/**
 * Compose State URL based on the current listing state.
 */
function initStateURL() {
    let base_url;


    // Resolve Base URL.

    // Home.
    if ( typeof home !== 'undefined' ) {
        base_url = home.base_url;
    }

    // Trainings.
    if ( typeof trainings !== 'undefined' ) {
        base_url = trainings.base_url;
    }

    // Knowledge Base.
    if ( typeof knowledgebase !== 'undefined' ) {
        base_url = knowledgebase.base_url;
    }

    // Skip if not defined.
    if ( ! base_url ) {
        return;
    }

    let initUrl = new URL( base_url );

    let categoryId = $('#kb-category option:selected').val();

    if ( categoryId ) {
        initUrl.searchParams.set('kategoria', categoryId);
        showClearAllButton();
    }

    let topicId = $('#topic-filter input:checked').attr('data-id');

    if ( topicId ) {
        initUrl.searchParams.set('tematyka', topicId);
        showClearAllButton();
        showClearTopicsButton();
    }

    let expertId = $('#kb-expert option:selected').val();

    if ( expertId ) {
        initUrl.searchParams.set('ekspert', expertId);
        showClearAllButton();
    }

    let fromDate = $('#date-from-filter').val();

    if ( fromDate ) {
        initUrl.searchParams.set('od', fromDate);
        showClearAllButton();
    }

    let toDate = $('#date-to-filter').val();

    if ( toDate ) {
        initUrl.searchParams.set('do', toDate);
        showClearAllButton();
    }

    let $type = $('.kb-main-filters__filter--active');

    if ($type.length > 0) {
        initUrl.searchParams.set('typ', $type.attr('id'));
    }

    let page = parseInt($('.kb-pagination.kb-pagination--bottom li[aria-current=page]').text(), 10);

    if (page) {
        initUrl.searchParams.set('strona', page);
    }

    stateUrl = initUrl.href;
}

/**
 * Use that function to update browser URL
 *
 * @param url
 */
function updateBrowserURL(url) {
    // Uncomment to enable browser URL change.
    window.history.pushState( {}, '', url );
}


function showClearAllButton() {
    const clearAllButtonWrapper = document.querySelector( '#left-column .kb-filter__clear.kb-filter__clear--all' );

    if ( clearAllButtonWrapper.getAttribute( 'style' ) !== 'display: block;' ) {
        clearAllButtonWrapper.style.display = 'block';
        document.querySelector( '#left-column' ).style.paddingTop = '45px';
    }
}

function showClearTopicsButton() {
    const filter = document.getElementById( 'topic-filter' );
    const clearButtonWrapper = filter.querySelector( '.kb-filter__heading .kb-filter__clear' );

    if ( clearButtonWrapper.getAttribute( 'style' ) !== 'display: block;' ) {
        clearButtonWrapper.style.display = 'block';
    }
}

/**
 * Select2
 */
(function($) {
    
    if ( ! document.querySelector( '.kb-main-courses' ) || document.querySelector( 'body' ).classList.contains( 'single-sm_trainer' ) ) {
        return;
    }

    if( document.querySelector( '#kb-expert' ) ) {
        $('#kb-expert').select2({
            placeholder: "Wszyscy",
            language: {
                noResults: function() {
                    return "Nie znaleziono";
                }
            },
            minimumResultsForSearch: Infinity,
            templateResult: formatOptions,
        });
        $('#kb-expert').on('select2:select', function (event) {
            manageSelect2Filtering( event, 'ekspert' )
        }); 
    }
    
    if( document.querySelector( '#kb-category' ) ) {
        $('#kb-category').select2({
            placeholder: "Wszystkie kategorie",
            language: {
                noResults: function() {
                    return "Nie znaleziono";
                }
            },
            minimumResultsForSearch: Infinity,
            templateResult: formatOptions,
        });
        $('#kb-category').on('select2:select', function (event) {
            manageSelect2Filtering( event, 'kategoria' )
        });
    }
    
    const url = new URL( applyBrowserURLFilter( window.location.href ) );
    const expert = url.searchParams.get( 'ekspert' );
    const category = url.searchParams.get( 'kategoria' );

    function formatOptions(option) {
        if (!option.id) {
            return option.text;
        }

        const formattedOption = $('<span>' + option.text + '</span>');

        if ( $(option.element).data('count') === 0 ) {
            formattedOption.addClass('kb-filter__option--empty');
        }

        return formattedOption;
    }

    const emptyExperts = $('#kb-expert').find('option[data-count="0"]');
    $('#kb-expert').append(emptyExperts);

    if ( expert ) {
        const selectedOption = $('#kb-expert').find('option[value="' + expert + '"]');
        const allOption = $('#kb-expert').find('option[value="all"]');
        $('#kb-expert').val(expert);
        $('#kb-expert').prepend(selectedOption);
        $('#kb-expert').prepend(allOption);
        $('#kb-expert').trigger('change');
    }

    if ( category ) {
        $('#kb-category').val(category);
        $('#kb-category').trigger('change');
    }
})(jQuery);

/**
 * Filter posts
 *
 * @param {object} url Url with filters
 * @param {string} filterType Type of filter
 */
function filterPosts( url, filterType ) {
    stateUrl = url;

    return new Promise( function(resolve, reject) {
        $.ajax( {
            url: url.href,
            type: 'get',
            beforeSend: function() {
                $('body').addClass('loading');
            },
            success: function( result ) {
                var $new_content = $(result).find('.kb-main');
                $('.kb-main').replaceWith($new_content);
                $('body').removeClass('loading');
                manageTypesFiltering();
                managePagination();
                manageMobileFilters();
                manageFiltering( 'topic-filter', 'tematyka', 'radio' );
                manageFiltering( 'date-from-filter', 'od', 'date' );
                manageFiltering( 'date-to-filter', 'do', 'date' );
                checkInput( 'topic-filter', 'tematyka', 'radio' );
                checkInput( 'date-from-filter', 'od', 'date' );
                checkInput( 'date-to-filter', 'do', 'date' );
                manageClearingAll( [ 'kategoria', 'tematyka', 'ekspert', 'od', 'do','promocja' ] );
                disableEmptyOptions();
                initDatepickers(jQuery);
                showClearButtons( 'topic-filter', 'tematyka' );
                setMobileMenuPosition();

                if ( $(".owl-carousel.kb-main-courses").length > 0 ) {
                    initializeOwlCarousel();
                }

                if ( $.isFunction($.fn.select2) ) {

                    (function($) {
                        $('#kb-expert').select2({
                            placeholder: "Wszyscy",
                            language: {
                                noResults: function() {
                                    return "Nie znaleziono";
                                }
                            },
                            minimumResultsForSearch: Infinity,
                            templateResult: formatOptions,
                        });
                        $('#kb-expert').on('select2:select', function (event) {
                            manageSelect2Filtering( event, 'ekspert' )
                        });
                    
                        $('#kb-category').select2({
                            placeholder: "Wszystkie kategorie",
                            language: {
                                noResults: function() {
                                    return "Nie znaleziono";
                                }
                            },
                            minimumResultsForSearch: Infinity,
                            templateResult: formatOptions,
                        });
                        $('#kb-category').on('select2:select', function (event) {
                            manageSelect2Filtering( event, 'kategoria' )
                        });
                        
                        const url = new URL( applyBrowserURLFilter( window.location.href ) );
                        const expert = url.searchParams.get( 'ekspert' );
                        const category = url.searchParams.get( 'kategoria' );
    
                        function formatOptions(option) {
                            if (!option.id) {
                                return option.text;
                            }
                    
                            const formattedOption = $('<span>' + option.text + '</span>');
    
                            if ( $(option.element).data('count') === 0 ) {
                                formattedOption.addClass('kb-filter__option--empty');
                            }
                    
                            return formattedOption;
                        }
    
                        const emptyExperts = $('#kb-expert').find('option[data-count="0"]');
                        $('#kb-expert').append(emptyExperts);
                    
                        if ( expert ) {
                            const selectedOption = $('#kb-expert').find('option[value="' + expert + '"]');
                            const allOption = $('#kb-expert').find('option[value="all"]');
                            $('#kb-expert').val(expert);
                            $('#kb-expert').prepend(selectedOption);
                            $('#kb-expert').prepend(allOption);
                            $('#kb-expert').trigger('change');
                        }
                    
                        if ( category ) {
                            $('#kb-category').val(category);
                            $('#kb-category').trigger('change');
                        }

                    })(jQuery);
                }

                if ( $( window ).width() > 767 ) {
                    setTopSpace( [document.querySelector('.kb-main')] );
                }

                if ( filterType === 'main' ) {
                    openFilters( false );
                }
                resolve(result);
            },
            error: function( error ){
                console.log( error );
                reject(error);
            }
        } );
    } );

}


/**
 * Filter by type of post
 */
function manageTypesFiltering() {

    const filterWrapper = document.querySelector( '.kb-main-filters' );
  
    if ( ! filterWrapper ) {
        return;
    }

    const filters = filterWrapper.querySelectorAll( '.kb-main-filters__filter:not(.kb-main-filters__filter--inactive)' );
    const firstFilter = filterWrapper.querySelector( '.kb-main-filters__filter:first-child' );
    let browserUrl = new URL( window.location.href );
  
    filters.forEach( ( filter ) => {
  
        const filterId = filter.getAttribute( 'id' );
        let url = new URL( applyBrowserURLFilter( window.location.href ) );

        if ( url.searchParams.get( 'typ' ) === null ) {
            firstFilter.classList.add( 'kb-main-filters__filter--active' );
        } else {
            if ( url.searchParams.get( 'typ' ) === filterId ) {
                filter.classList.add( 'kb-main-filters__filter--active' );
            } else {
                filter.classList.remove( 'kb-main-filters__filter--active' );
            }
        }

        if ( browserUrl.searchParams.get( 'typ' ) !== null ) {
            if ( browserUrl.searchParams.get( 'typ' ) === filterId ) {
                filter.classList.add( 'kb-main-filters__filter--active' );
            } else {
                filter.classList.remove( 'kb-main-filters__filter--active' );
            }
        }
  
        filter.addEventListener( 'click', () => {

            if ( browserUrl.searchParams.get( 'typ' ) !== null ) {
                browserUrl.searchParams.delete( 'typ' );
                window.history.pushState( {}, '', browserUrl );
            }
  
            filters.forEach( ( filter ) => {
                filter.classList.remove( 'kb-main-filters__filter--active' );
            })
    
            filter.classList.add( 'kb-main-filters__filter--active' );
            url.searchParams.set( 'typ', filterId );
    
            if ( url.searchParams.get( 'strona' ) ) {
                url.searchParams.delete( 'strona' );
            }

            updateBrowserURL(url);

            filterPosts( url )
                .then(function() {
                    if ( filterId === 'live_meetingi' || filterId === 'szkolenia_online' ) {
                        getFiltersDataForGA( url );
                    }
                })
                .catch(function(error) {
                    console.error('Error in AJAX request:', error);
                });
        })
    })
}

/**
 * Show or display next/prev buttons, page buttons and dots, go to page on button click
 *
 * @param {string} page Name of page
 */
function managePagination( page ) {

    const paginations = document.querySelectorAll( '.kb-pagination' );
    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    paginations.forEach( ( pagination ) => {

        const currentPage = parseInt( pagination.querySelector( '.kb-pagination__num[aria-current]' ).textContent );
        const lastPage = parseInt( pagination.getAttribute( 'data-pagescount' ) );
        const nextButton = pagination.querySelector( '.kb-pagination__goto--next' );

        const bottomPagination = document.querySelector( '.kb-pagination--bottom' );
        const prevDots = bottomPagination.querySelector( '.kb-pagination__dots--previous' );
        const nextDots = bottomPagination.querySelector( '.kb-pagination__dots--next' );
        const prevButton = bottomPagination.querySelector( '.kb-pagination__goto--previous' );
        const firstPageButton = bottomPagination.querySelector( '.kb-pagination__num--first' );
        const lastPageButton = bottomPagination.querySelector( '.kb-pagination__num--last' );
        var moveByOnebuttons = [ prevButton, nextButton ];

        if ( bottomPagination ) {
            const pagesButtons = bottomPagination.querySelectorAll( '.kb-pagination__num' );

            pagesButtons.forEach( ( button ) => {

                if ( button.textContent < 1 || button.textContent > lastPage ) {
                  button.style.display = 'none';
                }

                if ( page !== 'experts' ) {
                    button.addEventListener( 'click', ( event ) => {
                        event.preventDefault();
                        let link = button.querySelector( 'a' ).getAttribute( 'href' );
                        link = new URL( link );
                        const page = link.searchParams.get( 'strona' );
    
                        url.searchParams.set( 'strona', page );
    
                        url.href = decodeURIComponent( url.href );
                        updateBrowserURL(url);
    
                        let mainContainerTopOffset = document.querySelector('.kb-main').offsetTop;
    
                        window.scrollTo(0, mainContainerTopOffset);
                        filterPosts( url );
    
                    } );
                }

            })
        }

        if ( prevDots ) {
            if ( ( screen.width < 768 || window.innerWidth < 768 ) ) {
                if ( currentPage < 3 ) {
                  prevDots.style.display = 'none';
                }
            } else {
                if ( currentPage < 5 ) {
                  prevDots.style.display = 'none';
                }
            }
        }

        if ( firstPageButton ) {
            if ( ( screen.width < 768 || window.innerWidth < 768 ) && firstPageButton ) {
                if ( currentPage < 2 ) {
                  firstPageButton.style.display = 'none';
                }
            } else {
                if ( currentPage < 4 ) {
                  firstPageButton.style.display = 'none';
                }
            }
        }

        if ( nextDots ) {
            if ( ( screen.width < 768 || window.innerWidth < 768 ) ) {
                if ( currentPage > lastPage - 2 ) {
                  nextDots.style.display = 'none';
                }
            } else {
                if ( currentPage > lastPage - 4 ) {
                  nextDots.style.display = 'none';
                }
            }
        }

        if ( lastPageButton ) {
            if ( ( screen.width < 768 || window.innerWidth < 768 ) ) {
                if ( currentPage > lastPage - 1 ) {
                  lastPageButton.style.display = 'none';
                }
            } else {
                if ( currentPage > lastPage - 3 ) {
                  lastPageButton.style.display = 'none';
                }
            }
        }

        if ( page !== 'experts' ) {
            moveByOnebuttons.forEach( ( button ) => {

                if ( button ) {
                    button.addEventListener( 'click', ( event ) => {
                        event.preventDefault();
                        let link = button.querySelector( 'a' ).getAttribute( 'href' );
                        link = new URL( link );
                        const page = link.searchParams.get( 'strona' );
                        const paginationType = button.closest( 'nav' );
        
                        url.searchParams.set( 'strona', page );
        
                        url.href = decodeURIComponent( url.href );
                        updateBrowserURL(url);
        
                        if ( paginationType.classList.contains( 'kb-pagination--bottom' ) ) {
                            let mainContainerTopOffset = document.querySelector('.kb-main').offsetTop;
        
                            window.scrollTo(0, mainContainerTopOffset);
                        }
        
                        filterPosts( url );
        
                    } );
                }
    
            })
        }

    })
}

/**
 * Close mobile filters
 */
function closeFilters() {
    const filters = document.querySelector( '.kb-main__leftcolumn' );
    const openButton = document.querySelector( '.kb-mobile-filters button' );
    const mainContent = document.querySelector( '.site-content' );
    const header = document.querySelector( 'header.header' );

    if ( ! filters || ! openButton || ! mainContent ) {
      return;
    }

    filters.classList.remove( 'kb-main__leftcolumn--opened' );
    filters.classList.remove( 'kb-main__leftcolumn--opened-no-animation' );
    mainContent.classList.remove( 'site-content--filtersopened' );
    header.classList.remove( 'header--filtersopened' );
    openButton.setAttribute( 'aria-expanded', 'false' );
}

/**
 * Open mobile filters
 *
 * @param {bool} animation If filters should open with animation
 */
function openFilters( animation ) {
    const filters = document.querySelector( '.kb-main__leftcolumn' );
    const openButton = document.querySelector( '.kb-mobile-filters button' );
    const mainContent = document.querySelector( '.site-content' );
    const header = document.querySelector( 'header.header' );

    if ( ! filters || ! openButton || ! mainContent ) {
        return;
    }

    if ( ! animation ) {
        filters.classList.remove( 'kb-main__leftcolumn--opened' );
        filters.classList.add( 'kb-main__leftcolumn--opened-no-animation' );
    } else {
        filters.classList.add( 'kb-main__leftcolumn--opened' );
    }

    mainContent.classList.add( 'site-content--filtersopened' );
    header.classList.add( 'header--filtersopened' );
    openButton.setAttribute( 'aria-expanded', 'true' );
}

/**
 * Open and close filters section on mobile
 */
function manageMobileFilters() {
    const filters = document.querySelector( '.kb-main__leftcolumn' );
    const openButton = document.querySelector( '.kb-mobile-filters button' );
    const mainContent = document.querySelector( '.site-content' );

    if ( ! filters || ! openButton || ! mainContent ) {
        return;
    }

    const closeButton = filters.querySelector( '.kb-filter__mobileclose' );

    openButton.addEventListener( 'click', openFilters );
    closeButton.addEventListener( 'click', closeFilters );

    document.addEventListener( 'click', ( event ) => {
        if ( event.target === mainContent && event.target !== openButton ) {
            closeFilters();
        }
    })

    document.addEventListener( 'keydown', ( event ) => {
        if ( event.key === 'Escape' ) {
            closeFilters();
        }
    });
}

/**
 * Add filter param
 *
 * @param {string} filterId   Id attribute of filter
 * @param {string} filterName Url parameter for filtering
 * @param {string} type       Radio or date input type
 */
function manageFiltering( filterId, filterName, type ) {

    const filter = document.getElementById( filterId );

    if ( ! filter ) {
        return;
    }

    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    if ( type === 'radio' ) {
        const inputs = filter.querySelectorAll( '.kb-filter__element input' );
        const clearButtonWrapper = filter.querySelector( '.kb-filter__heading .kb-filter__clear' );

        inputs.forEach( ( input ) => {
            const element_id = input.getAttribute( 'data-id' );

            input.addEventListener( 'click', () => {

                if ( clearButtonWrapper.getAttribute( 'style' ) !== 'display: block;' ) {
                    clearButtonWrapper.style.display = 'block';
                }

                if ( input.checked ) {
                    url.searchParams.set( filterName, element_id );
                }

                if ( url.searchParams.get( 'strona' ) ) {
                    url.searchParams.delete( 'strona' );
                }

                openFilters( false );

                url.href = decodeURIComponent( url.href );
                updateBrowserURL(url);

                filterPosts( url, 'main' )
                    .then(function() {
                        getFiltersDataForGA( url );
                    })
                    .catch(function(error) {
                        console.error('Error in AJAX request:', error);
                    });
            });

        } );

        clearButtonWrapper.addEventListener( 'click', () => {
            inputs.forEach( ( input ) => {
                input.checked = false;
            });

            url.searchParams.delete( filterName );

            if ( url.searchParams.get( 'strona' ) ) {
                url.searchParams.delete( 'strona' );
            }

            openFilters( false );

            url.href = decodeURIComponent( url.href );
            updateBrowserURL(url);
            filterPosts( url, 'main' );

            clearButtonWrapper.style.display = 'none';
        })
    }

    if ( type === 'date' ) {

        const rangeInput = document.getElementById( 'date-range-filter' );
        const allInput = document.getElementById( 'all-dates-filter' );
        const fromInput = document.getElementById( 'date-from-filter' );
        const toInput = document.getElementById( 'date-to-filter' );

        filter.addEventListener( 'change', () => {

            url.searchParams.set( filterName, filter.value );

            if ( fromInput.value === '' && toInput.value === '' ) {
                rangeInput.checked = false;
                allInput.checked = true;
            } else {
                rangeInput.checked = true;
                allInput.checked = false;
            }

            if ( url.searchParams.get( 'strona' ) ) {
                url.searchParams.delete( 'strona' );
            }

            openFilters( false );

            url.href = decodeURIComponent( url.href );
            updateBrowserURL(url);
            filterPosts( url, 'main' );
        })
    }

}

/**
 * Add filter param for select2 options
 *
 * @param {string} filterName Url parameter for filtering
 * @param {object} event      select2 event
 */
function manageSelect2Filtering( event, filterName ) {
    const data = event.params.data;
    const id = data.id;

    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    if ( id === 'all' ) {
        url.searchParams.delete( filterName );
    } else {
        url.searchParams.set( filterName, id );
    }

    if ( url.searchParams.get( 'strona' ) ) {
      url.searchParams.delete( 'strona' );
    }

    openFilters( false );

    updateBrowserURL(url);

    filterPosts( url, 'main' )
        .then(function() {
            if ( filterName === 'kategoria' ) {
                getFiltersDataForGA( url );
            }
        })
        .catch(function(error) {
            console.error('Error in AJAX request:', error);
        });

}

/**
 * Check input if there is search param in url
 *
 * @param {string} filterId   Id attribute of filter
 * @param {string} filterName Url parameter for filtering
 * @param {string} type       Radio or date input type
 */
function checkInput( filterId, filterName, type ) {

    const filter = document.getElementById( filterId );

    if ( ! filter ) {
        return;
    }

    const url = new URL( applyBrowserURLFilter( window.location.href ) );
    const filterValue = url.searchParams.get( filterName );

    if ( filterValue === null || filterValue === '' ) {
        return;
    }

    if ( type === 'radio' ) {
        const inputs = filter.querySelectorAll( '.kb-filter__element input' );

        let filterValues = [];

        filterValues.push( filterValue );

        inputs.forEach( ( input ) => {
            const id = input.getAttribute( 'data-id' );;

            if ( filterValues.includes( id ) ) {
                input.checked = true;
            }
        })
    }

    if ( type === 'date' ) {
        const rangeInput = document.getElementById( 'date-range-filter' );
        const allInput = document.getElementById( 'all-dates-filter' );

        filter.value = filterValue;
        rangeInput.checked = true;
        allInput.checked = false;
    }

}

/**
 * Manage clear all button and date resetting
 *
 * @param {array} filterNames Url parameter for filtering
 */
function manageClearingAll( filterNames ) {

    const clearAllButtonWrapper = document.querySelector( '#left-column .kb-filter__clear.kb-filter__clear--all' );
    const inputs = document.querySelectorAll( '#left-column .kb-filter__element input' );
    const leftColumn = document.querySelector( '#left-column' );
    const rangeInput = document.getElementById( 'date-range-filter' );
    const allInput = document.getElementById( 'all-dates-filter' );

    if ( ! clearAllButtonWrapper || inputs.length === 0 ) {
      return;
    }

    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    inputs.forEach( ( input ) => {

        input.addEventListener( 'click', () => {
            if ( clearAllButtonWrapper.getAttribute( 'style' ) !== 'display: block;' ) {
                clearAllButtonWrapper.style.display = 'block';
                leftColumn.style.paddingTop = '45px';
            }

            const checkedInputs = [];

            inputs.forEach( ( input ) => {

                if ( input.checked === true ) {
                    checkedInputs.push( input );
                }
            })

            if ( checkedInputs.length === 0 ) {
                clearAllButtonWrapper.style.display = 'none';
                leftColumn.style.removeProperty('paddingTop');
            }
        })

    })

    filterNames.forEach( ( filter ) => {
        if ( url.searchParams.get( filter ) || (filter ==='promocja' && url.searchParams.get( filter ) !== null)  ) {
            if ( clearAllButtonWrapper.getAttribute( 'style' ) !== 'display: block;' ) {
                clearAllButtonWrapper.style.display = 'block';
                leftColumn.style.paddingTop = '45px';
            }
        }
    })

    clearAllButtonWrapper.addEventListener( 'click', () => {
        inputs.forEach( ( input ) => {
            input.checked = false;
        } );

        if ( rangeInput.checked ) {
            rangeInput.checked = false;
        }

        if ( ! allInput.checked ) {
            allInput.checked = true;
        }

        filterNames.forEach( ( filter ) => {
            url.searchParams.delete( filter );
        } );

        if ( url.searchParams.get( 'strona' ) ) {
            url.searchParams.delete( 'strona' );
        }

        openFilters( false );

        updateBrowserURL(url);
        filterPosts( url, 'main' );

        clearAllButtonWrapper.style.display = 'none';
        leftColumn.style.removeProperty('paddingTop');
    })

    allInput.addEventListener( 'click', () => {

        if ( rangeInput.checked ) {
            rangeInput.checked = false;
        }

        if ( url.searchParams.get( 'strona' ) ) {
            url.searchParams.delete( 'strona' );
        }

        if ( url.searchParams.get( 'od' ) || url.searchParams.get( 'do' ) ) {
            url.searchParams.delete( 'od' );
            url.searchParams.delete( 'do' );
        }

        openFilters( false );

        updateBrowserURL(url);
        filterPosts( url, 'main' );
    })
}

/**
 * Disable topic options with no posts
 */
function disableEmptyOptions() {
    // let's disable it for now
    return;







    const topicFilter = document.getElementById( 'topic-filter' );

    if ( ! topicFilter ) {
      return;
    }

    const options = topicFilter.querySelectorAll( '.kb-filter__element' );

    options.forEach( ( option ) => {
        const input = option.querySelector( 'input' );
        const count = input.getAttribute( 'data-count' );

        if ( count === '0' ) {
            input.setAttribute( 'disabled', 'true' );
            option.classList.add( 'kb-filter__element--empty' );
        }
    })
}

class pikDatePicker {
    #id;
    #date;
    #input;
    #clearButton;
    #$input;
    #onChangeCallback;

    HIGHLIGHT_CSS_CLASS = 'highlight';

    constructor(id) {
        this.#id = id;

        this.#init();
    }

    get id() {
        return this.#id;
    }

    get date() {
        return this.#date;
    }

    setDate(date) {
        this.#date = date;
        this.#showClearButton();

        this.#onChangeCallback(this);
    }

    clearDate() {
        this.#date = null;
        this.#$input.datepicker( 'setDate', null );
        this.#hideClearButton();

        this.#onChangeCallback(this);
    }

    setMinDate(date) {
        this.#$input.datepicker( 'option', 'minDate', date );
    }

    setMaxDate(date) {
        this.#$input.datepicker( 'option', 'maxDate', date );
    }

    onChange(callback) {
        this.#onChangeCallback = callback;
    }

    #init() {
        this.#initDatePickerControl();
        this.#initClearDateButton();
    }

    #initDatePickerControl() {
        this.#input = document.getElementById(this.#id);

        if (!this.#input) {
            return;
        }

        // Allow to access the datepicker object from the DOM input element.
        this.#input.pikDatePicker = this;


        this.#$input = jQuery(this.#input);

        // Apply jQuery Datepicker.
        this.#$input.datepicker({
            'dateFormat':     'yy-mm-dd',
            'onSelect':       (date, datepicker) => {
                this.#onSelect(date);
            },
            'beforeShowDay':  (date) => {
                return this.#beforeShowDateCell(date);
            }
        });

        $.datepicker.regional['pl'] = {
            firstDay: 1,
            prevText: 'Poprzedni',
            nextText: 'Następny',
            monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
            dayNamesMin: ['Ndz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        };

        $.datepicker.setDefaults($.datepicker.regional['pl']);
    }

    #initClearDateButton() {
        this.#clearButton = document.getElementById(this.#id + '-clear');

        if (!this.#clearButton) {
            return;
        }

        if (this.#input.value !== '') {
            this.#showClearButton();
        }

        this.#clearButton.addEventListener('click', () => {
            this.clearDate();
            this.#input.dispatchEvent(new Event('change'));
        }, false);
    }

    #onSelect(date) {
        this.setDate(date);
        this.#input.dispatchEvent(new Event('change'));
    }

    #beforeShowDateCell(date) {
        // Default.
        let dateIsSelectable = true;
        let dateCellCSSClass = '';
        let dateCellTooltip = '';

        const currentCellTime = new Date(date).getTime();

        const selectedDate = this.#date;
        const selectedDateTime = new Date(selectedDate + ' 00:00:00').getTime();

        const minDate = this.#$input.datepicker( "option", "minDate" );
        const minDateTime = new Date(minDate + ' 00:00:00').getTime();
        const maxDate = this.#$input.datepicker( "option", "maxDate" );
        const maxDateTime = new Date(maxDate + ' 00:00:00').getTime();

        const fromDate = this.#id.indexOf('from') > 0;

        // Date selected.
        if (selectedDate) {
            // Highlight cells after the selected date.
            if (fromDate && currentCellTime >= selectedDateTime) {
                if (maxDate) {
                    // Highlight cells before the max date.
                    if (currentCellTime <= maxDateTime) {
                        dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                    }
                } else {
                    dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                }
            }

            // Highlight cells before the selected date.
            if (!fromDate && currentCellTime <= selectedDateTime) {
                if (minDate) {
                    // Highlight cells after the min date.
                    if (currentCellTime >= minDateTime) {
                        dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                    }
                } else {
                    dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                }
            }
            // Date not selected.
        } else {
            if (fromDate && maxDate) {
                // Highlight cells before the max date.
                if (currentCellTime <= maxDateTime) {
                    dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                }
            }

            if (!fromDate && minDate) {
                // Highlight cells after the min date.
                if (currentCellTime >= minDateTime) {
                    dateCellCSSClass = this.HIGHLIGHT_CSS_CLASS;
                }
            }
        }

        return [ dateIsSelectable, dateCellCSSClass, dateCellTooltip ];
    }

    #showClearButton() {
        this.#clearButton.style.display = 'block';
    }

    #hideClearButton() {
        this.#clearButton.style.display = 'none';
    }
}

/**
 * Init jQuery Datepicker on date filters "From" and "To"
 */
function initDatepickers($) {
    const fromDatePicker = new pikDatePicker('date-from-filter');
    const toDatePicker = new pikDatePicker('date-to-filter');

    if ( ! fromDatePicker || ! toDatePicker ) {
        return;
    }

    fromDatePicker.onChange(function(datepicker) {
        toDatePicker.setMinDate(datepicker.date);
    });

    toDatePicker.onChange(function(datepicker) {
        fromDatePicker.setMaxDate(datepicker.date);
    });

    // Init.
    const fromInitDate = $('#date-from-filter').val();
    const toInitDate = $('#date-to-filter').val();

    if ( ! fromInitDate || ! toInitDate ) {
        return;
    }

    if (fromInitDate.length > 0) {
        fromDatePicker.setDate(fromInitDate);
    }

    if (toInitDate.length > 0) {
        toDatePicker.setDate(toInitDate);
    }
}

/**
 * Set articles as default tab on Baza wiedzy page load, on mobile
 */
function setDefaultType() {

    if ( window.location.pathname !== '/baza-wiedzy/' ) {
        return;
    }

    if ( screen.width >= 768 && window.innerWidth >= 768 ) {
        return;
    }

    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    url.searchParams.set( 'typ', 'artykuly' );
    updateBrowserURL(url);
    filterPosts( url );
}

/**
 * Show clear button if there is search param in url
 *
 * @param {string} filterId   Id attribute of filter
 * @param {string} filterName Url parameter for filtering
 */
function showClearButtons( filterId, filterName ) {

    const filter = document.getElementById( filterId );
  
    if ( ! filter ) {
        return;
    }

    const clearButtonWrapper = filter.querySelector( '.kb-filter__heading .kb-filter__clear' );
    let url = new URL( applyBrowserURLFilter( window.location.href ) );
  
    if ( url.searchParams.get( filterName ) ) {
        clearButtonWrapper.style.display = 'block';
    }

}

/**
 * Get data about chosen filter and send event to GTM
 *
 * @param {object} url Url with search params
 */
function getFiltersDataForGA( url ) {

    let listName = '';
    let listId = '';
    let categoryName = '';
    let topicName = '';
    const type = url.searchParams.get( 'typ' );

    if ( url.pathname === '/' ) {
        listName = 'Najbliższe wydarzenia';
    }

    if ( url.pathname === '/szkolenia/' ) {
        listName = 'Strona: Szkolenia';
    }

    if ( url.pathname === '/live-meetingi/' ) {
        listName = 'Strona: Live Meetingi';
    }

    listId = convertNameToId(listName);

    if ( document.querySelector( 'body' ).classList.contains( 'single-sm_trainer' ) ) {

        const expertName = document.querySelector( 'h1.wp-block-heading' ).textContent;

        if ( type === 'szkolenia_online' ) {
            listName = `Strona: ${expertName} - Szkolenia`;
        }

        if ( type === 'live_meetingi' ) {
            listName = `Strona: ${expertName} - Live Meetingi`;
        }
    } else {

        if ( type === 'szkolenia_online' ) {
            listName = `${listName} - Szkolenia`;
            listId = `${listId}-szkolenia`;
        }

        if ( type === 'live_meetingi' ) {
            listName = `${listName} - Live Meetingi`;
            listId = `${listId}-live-meetingi`;
        }
    }

    if ( url.searchParams.get('kategoria') ) {

        const categoriesWrapper = document.getElementById( 'category-filter' );
        const options = categoriesWrapper.querySelectorAll( 'option' );

        options.forEach( (option) => {
            if ( option.value === url.searchParams.get('kategoria') ) {
                categoryName = option.textContent;
            }
        })

        listName = `${listName} - ${categoryName}`;
        listId = `${listId}-${convertNameToId(categoryName)}`;

    }

    if ( url.searchParams.get('tematyka') ) {

        const topicsWrapper = document.getElementById( 'topic-filter' );
        const options = topicsWrapper.querySelectorAll( 'input' );

        options.forEach( (option) => {
            if ( url.searchParams.get('tematyka').includes( option.getAttribute('data-id') ) ) {
                const label = option.parentElement;
                topicName = label.querySelector( '.kb-filter__label > span' ).textContent;
            }
        })

        listName = `${listName} - ${topicName}`;
        listId = `${listId}-${convertNameToId(topicName)}`;
    }

    const dataForGA = {
        event: 'view_item_list',
        item_list_name: listName,
        item_list_id: listId,
        ecommerce: {                         
          items: []
        }
    }

    const eventsList = document.querySelector( '.kb-main-courses' );

    let trainings = [];

    if ( screen.width < 768 || window.innerWidth < 768 ) {
        trainings = eventsList.querySelectorAll( '.owl-item:not(.cloned) .course-card' );
    } else {
        trainings = eventsList.querySelectorAll( '.course-card' );
    }

    trainings.forEach( ( training, index ) => {
        getDataFromCourseCard( dataForGA, training, index, listName, listId );

        training.addEventListener( 'click', () => {
        
            dataForGA.event = 'select_item';
            dataForGA.ecommerce.items = [];
            delete dataForGA.item_list_name;
            delete dataForGA.item_list_id;

            getDataFromCourseCard( dataForGA, training, index, listName, listId );
            sendDataToGa4( dataForGA );
        })
    } )

    sendDataToGa4( dataForGA );

}

/**
 * On page load set as active first tab (only on trainers pages)
 */
function activateFirstTab() {

    if ( ! document.querySelector( 'body' ).classList.contains( 'single-sm_trainer' ) ) {
        return;
    }

    const firstTab = document.querySelector( '.kb-main-filters__filter' );

    if ( ! firstTab ) {
        return;
    }

    const id = firstTab.getAttribute( 'id' );
    let url = new URL( applyBrowserURLFilter( window.location.href ) );

    const type = url.searchParams.get( 'typ' );

    if ( type === null ) {
        firstTab.classList.add( 'kb-main-filters__filter--active' );

        url.searchParams.set( 'typ', id );
        filterPosts( url );
    }
    
}

window.addEventListener( 'DOMContentLoaded', () => {

    if ( document.querySelector( 'body' ).classList.contains( 'post-type-archive-sm_trainer' ) ) {
        managePagination( 'experts' );
    }

    if ( ! document.querySelector( '.kb-main-courses' ) ) {
        return;
    }

    //initStateURL();
    manageTypesFiltering();
    managePagination();
    manageMobileFilters();
    manageFiltering( 'topic-filter', 'tematyka', 'radio' );
    manageFiltering( 'date-from-filter', 'od', 'date' );
    manageFiltering( 'date-to-filter', 'do', 'date' );
    checkInput( 'topic-filter', 'tematyka', 'radio' );
    checkInput( 'date-from-filter', 'od', 'date' );
    checkInput( 'date-to-filter', 'do', 'date' );
    manageClearingAll( [ 'kategoria', 'tematyka', 'ekspert', 'od', 'do','promocja' ] );
    disableEmptyOptions();
    initDatepickers(jQuery);
    setDefaultType();
    showClearButtons( 'topic-filter', 'tematyka' );
    activateFirstTab();

    if ( $( window ).width() > 767 ) {
        setTopSpace( [document.querySelector('.kb-main')] );
    }

} );